import React, { useEffect } from 'react'
// import About1 from '../assets/imgs/About1.png'
import About2 from '../assets/imgs/About2.png'
import fac1 from '../assets/imgs/facility.png'
import fac2 from '../assets/imgs/facility1.png'
import fac3 from '../assets/imgs/facility2.png'
import Fabric from '../assets/jemin_fabric.png'
import Woven from '../assets/WOVEN-FABRIC.png'
import kint from '../assets/kint.png'

import p1 from '../assets/imgs/p1.png'
import GetEnquiry from '../component/GetEnquiry'

const About = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <div className='w-full xl:h-[50vh] md:h-[50vh] sm:h-[30vh] h-[30vh] backgroundImage mb-10'>
        <div className='w-full h-[100%] flex justify-end items-center flex-col overlayOtherPage '>
          <h1 className='text-[6vmax] font-bold text-white text-justify textShadow mt-2 mb-0 font-serif'>
            About <span className='text-blue-300'>Us</span>
          </h1>
        </div>
      </div>
      <div className='h-fit py-5 flex justify-between items-center px-5 flex-wrap mb-8'>
        <div className='xl:w-[45%] md:w-[95%]'>
          <img
            className='w-full h-[350px] mt-[10px]'
            src={p1}
            alt='GL Exports'
          />
        </div>
        <div className='xl:w-[50%] md:w-[95%] text-gray-600'>
          <div className='text-justify font-serif'>
            <h1 className='font-bold text-red-900 text-[20px] pt-4'>
              Your Trusted Denim Manufacturer & Supplier
            </h1>
            <p className='font-bold  text-[16px] text-bold mb-1'>
              {' '}
              Discover High-Quality Denim Tailored for Your Business
            </p>
            Denim is more than just fabric—it's a statement of quality,
            durability, and style. At GL Exports, we take pride in being a
            leading denim manufacturer, supplying top-notch jeans and apparel to
            businesses worldwide. Our expertise lies in crafting denim products
            that meet the demands of global fashion markets while ensuring
            comfort, longevity, and superior aesthetics.
            <br />
          </div>
        </div>
      </div>
      <div className='w-full h-fit'>
        <div className='w-[95%] pb-4 mx-auto bg-gray-0 text-gray-600 px-4'>
          <p className='text-red-700 text-[18px] font-bold mt-4'>
            What Sets Us Apart?
          </p>
          ✔ State-of-the-Art Production Facilities – Advanced technology and
          skilled craftsmanship come together to create unmatched denim
          products.
          <br /> ✔ Trend-Focused Designs – Stay ahead of the competition with
          denim styles that are always in demand.
          <br /> ✔ Flexible Order Volumes – From small-batch custom orders to
          mass production, we cater to all business sizes.
          <br /> ✔ Stringent Quality Control – Every piece undergoes thorough
          inspection to maintain international quality standards.
          <br /> ✔ Dedicated Client Support – Our team works closely with you,
          ensuring smooth communication and hassle-free order processing.
          <br />
          <p className='text-red-700 text-[18px] font-bold mt-4'>
            Explore Our Extensive Denim Line
          </p>
        👖 Fashion-Forward Jeans – From timeless classics to the latest cuts,
          we manufacture styles that align with current market trends.
          <br />👕 Versatile Denim Tops – Shirts and jackets designed for
          modern appeal and all-season wear. <br />
        👶 Kids' Denim Range – Durable, soft, and stylish denim apparel
          designed for active lifestyles.
          <br />🎨 Customization Services – Create your own private label with
          unique washes, fits, and branding options.
        </div>
      </div>
      <div className='w-full h-fit my-5 flex justify-center items-center'>
        <div className='xl:w-[100%] md:w-[100%] bg-gray-100 h-fit px-2 py-2 flex justify-center items-center'>
          <h1 className='px-20 w-full xl:text-xl md:text-lg mt-0 text-white text-center py-8 bg-red-400 mx-auto uppercase font-bold'>
            One of the India's fastest growing apparel manufacturer with 05
            factories based in DELHI and UP.
          </h1>
        </div>
      </div>

      <div className='w-full h-[70vh] flex justify-center items-center'>
        <img className='xl:w-[80%] md:w-[95%] h-[100%]' src={About2} alt='' />
      </div>

      <div className='w-full flex justify-center items-center'>
        <div className='w-[97%] bg-gray-100 px-4 py-2'>
          <h1 className='font-bold text-red-900 italic text-[20px]  mt-0'>
            Categories We Excel In:
          </h1>
          <ul className='font-serif pt-0 pl-5'>
            <li className='mt-1 tracking-wider'>
              <strong className='text-red-700 text-[16px]'>
                Woven Fabrics:
              </strong>
              <span className='text-gray-600'>
                Crafted with precision for strength and durability.
              </span>
            </li>
            <li className='mt-1 tracking-wider'>
              <strong className='text-red-700 text-[16px]'>Knits: </strong>
              <span className='text-gray-600'>
                Soft and flexible materials, perfect for comfortable wear.
              </span>
            </li>
            <li className='mt-1 tracking-wider'>
              <strong className='text-red-700 text-[16px]'>Denim: </strong>
              <span className='text-gray-600'>
                High-quality denim that stands the test of time in fashion and
                utility.
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className='h-fit py-5 flex justify-between items-center px-5 flex-wrap mb-5'>
        <div className='xl:w-[45%] md:w-[100%] sm:w-[100%] w-[100%]'>
          <img
            className='w-[100%] h-[320px] mt-[-10px]'
            src={Woven}
            alt='GLBM'
          />
        </div>
        <div className='xl:w-[50%] md:w-[95%] '>
          <p className='text-justify mt-2 font-serif text-gray-600'>
            Woven fabric is any textile formed by weaving. Woven fabrics are
            often created on a loom, and made of many threads woven on a warp
            and a weft. Technically, a woven fabric is any fabric made by
            interlacing two or more threads at right angles to one another.
          </p>
        </div>
      </div>

      <div className='h-fit py-5 flex justify-between items-center px-5 flex-wrap mb-5'>
        <div className='xl:w-[45%] md:w-[100%] sm:w-[100%] w-[100%] xl:order-2 sm:order-1'>
          <img
            className='w-[100%] h-[320px] mt-[-10px]'
            src={kint}
            alt='GLBM'
          />
        </div>
        <div className='xl:w-[50%] md:w-[95%] xl:order-1 sm:order-2 '>
          <p className='text-justify mt-2 font-serif text-gray-600'>
            Knit fabric is made from one continuous fiber, like yarn or thread,
            which is repeatedly looped to form a garment. If you look closely at
            a piece of knit clothing, you'll see a pattern that looks like rows
            of fine braids throughout the material.
          </p>
        </div>
      </div>

      <div className='h-fit py-5 flex justify-between items-center px-5 flex-wrap mb-5'>
        <div className='xl:w-[45%] md:w-[100%] sm:w-[100%] w-[100%]'>
          <img
            className='w-[100%] h-[320px] mt-[-10px]'
            src={Fabric}
            alt='GLBM'
          />
        </div>
        <div className='xl:w-[50%] md:w-[95%] '>
          <p className='text-justify mt-2 font-serif text-gray-600'>
            Denim. Denim is a durable, rugged cotton twill fabric that's most
            commonly used in jeans, jackets and overalls, as well as in other
            types of clothing. Denim is available in a range of colors, but the
            most common denim is INDIGO denim in which the WARP thread is dyed
            while the WEFT thread is left white.
          </p>
          <p className='text-justify mt-2 font-serif text-gray-600'>
            As a result of the warp-faced twill weaving, one side of the textile
            is dominated by the blue warp threads and the other side is
            dominated by the white weft threads. JEANS fabricated from this
            cloth are thus predominantly white on the inside.
          </p>
        </div>
      </div>

      <div className='w-full h-fit'>
        <div className='w-[95%] py-4 mx-auto bg-gray-100 px-4'>
          <h1 className='font-bold text-red-900 italic text-[20px] pt-4'>
            Why Choose GL Exports
          </h1>
          <ul className='font-serif pt-0 pl-5'>
            <li className='mt-1 tracking-wider'>
              <p className='text-red-700 text-[18px] font-bold mt-4'>
                Why Choose Us?
              </p>
              <span className='text-gray-600'>
                ✔ Manufacturer-Direct Pricing – Get the best rates by sourcing
                directly from our factory. <br />✔ Premium Fabric &
                Craftsmanship – We use high-quality denim fabrics and
                cutting-edge technology for durability and comfort. <br />
                ✔ Bulk & Custom Orders – We accommodate both large-scale
                production and custom designs to match your brand identity.
                <br />
                ✔ Sustainable Manufacturing – We are committed to eco-friendly
                production methods that reduce waste and environmental impact.
                <br />
                <p className='text-red-700 text-[18px] font-bold mt-4'>
                  Our Denim Collection
                </p>
                🔹 Men’s & Women’s Jeans – Classic, skinny, straight-leg,
                bootcut, and more. <br />
                🔹 Custom & Private Label Manufacturing – We bring your unique
                designs to life with branding and packaging solutions. <br />
                🔹 Children’s Denim Wear – Comfortable and durable options for
                kids.
                <br />
                Partner with Us for Your Denim Supply Needs With years of
                experience in denim manufacturing, we guarantee superior
                quality, competitive pricing, and timely delivery. Whether you
                are launching a new fashion line or expanding your existing
                collection, our team is ready to support you with innovative
                designs and flexible production capabilities.
              </span>
            </li>
          </ul>
        </div>
      </div>

      <p className='ml-16 font-bold text-[18px] text-red-900 italic paraTextShadow mt-8 mb-0 capitalize'>
        OUR FACILITY
      </p>
      <div className='h-fit pb-5 flex justify-center items-center  flex-wrap mb-5 px-5'>
        <div className='xl:w-[45%] md:w-[95%]'>
          <img className='w-full h-[320px] mt-5 mr-5' src={fac1} alt='GLBM' />
        </div>
        <div className='xl:w-[45%] md:w-[95%]'>
          <img className='w-full h-[320px] mt-5 ml-5' src={fac2} alt='GLBM' />
        </div>
      </div>

      <div className='w-full h-[50vh] flex justify-center items-center mb-10 px-2'>
        <img className='xl:w-[80%] md:w-[95%] h-[100%]' src={fac3} alt='' />
      </div>

      <div className='h-fit py-5 flex bg-gray-100 justify-between xl:px-10 lg:px-10 md:px-5 sm:px-5 px-5 flex-wrap mb-5'>
        <div className='xl:w-[45%] md:w-[95%] order-1'>
          <img className='w-full h-[320px]' src={Fabric} alt='GLBM' />
        </div>
        <div className='xl:w-[50%] md:w-[95%] order-2'>
          <h1 className='text-center text-[2.5rem] text-red-900'>
            GL Exports
          </h1>
          <ul className='ml-5 text-gray-600'>
            <li className='list-disc '>CUSTOMIZED</li>
            <li className='list-disc'>SAMPLING</li>
            <li className='list-disc'>BENCHMARKING</li>
          </ul>
          <h2 className='text-left mt-5 text-[1.5rem] text-red-900'>
            OverView
          </h2>
          <ul className='ml-5 text-gray-600'>
            <li className='list-disc'>Total Garments 36 Lacs Per Annum</li>
            <li className='list-disc'>
              Implemented scientific way of enhancing our productivity at par
              with international standards
            </li>
          </ul>
        </div>
      </div>

      <GetEnquiry />
    </>
  )
}

export default About
